import React from 'react';
import { Link as DomLink } from 'react-router-dom';
import { Button } from '.';

export const Link = ({ children, to, target, ...props }) => (
  <DomLink {...{ to, target }}>
    <Button {...props}>{children}</Button>
  </DomLink>
);
